import { UPDATE_FIND_AND_REPLACE_STATE } from '../../../../constants/ActionNameConstants';

export const updateFindAndReplaceState = (payload) => ({
  type: UPDATE_FIND_AND_REPLACE_STATE,
  payload: payload,
});
